// Description: Gestiona el carrito y el proceso de checkout para el iframe de la lista de Baby Shower.

document.addEventListener("DOMContentLoaded", () => {
  //-------------------------- 1. CONFIGURACIÓN Y ESTADO -----------------------------//

  const API_BASE_URL = "https://minibeeapp.cl/public/api/";
  const ANGULAR_APP_ORIGIN = "https://minibee-baby-shower-app.vercel.app";
  let listData = null;
  let shoppingCart = []; // Estado del carrito, vive solo en memoria.
  let isSubmittingCheckoutCheckout = false;

  //-------------------------- 2. SELECCIÓN DE ELEMENTOS DEL DOM -----------------------------//

  const cartIconBtn = document.querySelector(".baby-shower-cart-icon-btn");
  const cartCountElement = document.querySelector(".baby-shower-cart-count");
  const cartCountProductsTitle = document.querySelector('.baby-shower-cart-count-title');
  const cartModalOverlay = document.querySelector(".baby-shower-cart-modal-overlay");
  const cartItemsContainer = document.querySelector(".baby-shower-cart-items");
  const cartCloseBtns = document.querySelectorAll(".baby-shower-cart-close-btn, .baby-shower-cart-close-btn-secondary");
  const cartSubtotalAmount = document.querySelector(".baby-shower-cart-subtotal-amount");
  const cartCheckoutBtn = document.querySelector(".baby-shower-cart-checkout-btn");
  
  // Carrito botón flotante
  const floatingCartBtn = document.querySelector(".baby-shower-floating-cart-btn");
  const floatingCartCount = document.querySelector(".baby-shower-floating-cart-count");

  //-------------------------- 3. FUNCIONES DE UTILIDAD -----------------------------//

  // Formatea un número como moneda chilena (CLP)
  const formatCurrency = (amount) => {
    return `$${Number(amount).toLocaleString("es-CL")} CLP`;
  };

  // Método para mostrar el modal y su error de checkout
  const showCheckoutErrorModal = (title, messageContent) => {
    const modal = document.getElementById('modal-error-checkout');
    if (!modal) return; // Si no existe, no hacemos nada

    // Actualizamos título y mensaje
    const titleEl = modal.querySelector('.modal__title');
    const bodyEl = modal.querySelector('.modal__body p');

    if (titleEl) titleEl.textContent = title;
    if (bodyEl) bodyEl.innerHTML = messageContent;

    // Mostramos modal
    modal.classList.add('is-visible');

    // Botones de cierre
    const closeBtns = modal.querySelectorAll('.modal__close, .modal__footer .button');
    closeBtns.forEach(btn => {
      btn.addEventListener('click', () => modal.classList.remove('is-visible'), { once: true });
    });
  };


  // Crea y muestra un modal de alerta simple y personalizable.
  const createAlertModal = (message, isError = true) => {
    const type = isError ? 'error' : 'success';
    let backgroundColor;
    let textColor = '#FFFFFF';

    switch (type) {
      case 'success':
        backgroundColor = '#7bbf7b';
        break;
      case 'error':
        backgroundColor = '#de5151';
        break;
      default:
        backgroundColor = '#7bbf7b';
        break;
    }

    // Contenido del mensaje
    const messageContent = document.createElement('div');
    messageContent.style.display = 'flex';
    messageContent.style.flexDirection = 'column';
    messageContent.style.fontSize = '12.5px';
    messageContent.innerHTML = message;

    // Mostrar toast con Toastify
    Toastify({
      node: messageContent,
      duration: 3000,
      close: true,
      gravity: 'top', // top o bottom
      position: 'right', // left, center o right
      stopOnFocus: true,
      offset: {
        x: '5px',
        y: '10px'
      },
      style: {
        background: backgroundColor,
        color: textColor,
        fontSize: '13px',
        fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "San Francisco", "Segoe UI", Roboto, "Helvetica Neue", sans-serif',
        lineHeight: '1.5',
        fontWeight: '600',
        borderRadius: '8px',
      },
    }).showToast();
  };

  //-------------------------- 4. LÓGICA DEL CARRITO DE COMPRAS -----------------------------//

  // Añade un producto al carrito o actualiza su cantidad si ya existe.
  const addToCart = (product) => {
    if (!product || !product.variantId) {
      console.error("Intento de agregar un producto inválido:", product);
      return;
    }

    // Validaciones clave basadas en el payload completo
    if (!product.availableForSale) {
      createAlertModal("Este producto no está disponible para la venta en este momento.");
      return;
    }

    const requested = parseInt(product.requestedQuantity, 10);
    const purchased = parseInt(product.purchasedQuantity, 10) || 0;
    const maxAvailableForGift = requested - purchased;

    if (maxAvailableForGift <= 0) {
      createAlertModal("Este producto ya está totalmente comprado.");
      return;
    }

    const stockShopify = parseInt(product.quantityAvailableShopify, 10);
    // Si el producto no es de preventa (stock > 0), el máximo es el menor entre el stock y lo que falta por regalar.
    // Si es preventa (stock <= 0), el único límite es lo que falta por regalar.
    const effectiveMax = (stockShopify > 0) ? Math.min(stockShopify, maxAvailableForGift) : maxAvailableForGift;

    const existingCartItem = shoppingCart.find(item => item.variantId === product.variantId);

    if (existingCartItem) {
      const newQuantity = existingCartItem.quantity + product.quantity;
      existingCartItem.quantity = Math.min(newQuantity, effectiveMax);
    } else {
      const initialQuantity = Math.min(product.quantity, effectiveMax);
      shoppingCart.push({
        ...product,
        quantity: initialQuantity
      });
    }

    updateCartDisplay();
    openCartModal();
  };

  // Actualiza la cantidad de un item específico en el carrito.
  const updateCartItemQuantity = (variantId, newQuantity) => {
    const itemIndex = shoppingCart.findIndex(item => item.variantId === variantId);
    if (itemIndex === -1) return;

    const item = shoppingCart[itemIndex];
    const requested = parseInt(item.requestedQuantity, 10);
    const purchased = parseInt(item.purchasedQuantity, 10) || 0;
    const maxAvailableForGift = requested - purchased;
    const stockShopify = parseInt(item.quantityAvailableShopify, 10);
    const effectiveMax = (stockShopify > 0) ? Math.min(stockShopify, maxAvailableForGift) : maxAvailableForGift;

    if (newQuantity <= 0) {
      removeFromCart(variantId);
    } else {
      item.quantity = Math.min(newQuantity, effectiveMax);
    }

    updateCartDisplay();
  };

  // Elimina un producto del carrito.
  const removeFromCart = (variantId) => {
    shoppingCart = shoppingCart.filter(item => item.variantId !== variantId);
    updateCartDisplay();
  };

  // Reinicia el carrito de compras a su estado inicial.
  const resetCart = () => {
    shoppingCart = []; // Vacía el array de productos
    //console.log('%c[PADRE-SHOPIFY]: Carrito reiniciado.', 'color: orange; font-weight: bold;');
    updateCartDisplay(); // Actualiza la UI para mostrar el carrito vacío
  };  


  //-------------------------- 5. RENDERIZADO Y UI DEL CARRITO -----------------------------//

  // Actualiza y renderiza el contenido del modal del carrito.
  const updateCartDisplay = () => {
    if (!cartItemsContainer) return;

    cartItemsContainer.innerHTML = "";
    let subtotal = 0;

    if (shoppingCart.length === 0) {
      cartItemsContainer.innerHTML = '<p class="baby-shower-cart-empty-message">Tu carrito de regalos está vacío.</p>';
    } else {
      shoppingCart.forEach(item => {
        const itemTotal = (Number(item.price) || 0) * item.quantity;
        // Estilo para el precio con/sin oferta
        const priceHtml = item.compareAtPrice && item.compareAtPrice > item.price ?
          `<div class="baby-shower-cart-item-price-container">
                <span class="baby-shower-cart-item-price-discount">${formatCurrency(item.price)}</span>
                <span class="baby-shower-cart-item-price-original">${formatCurrency(item.compareAtPrice)}</span>
             </div>` :
          `<span class="baby-shower-cart-item-price">${formatCurrency(item.price)}</span>`;
        // Calculamos el subtotal
        subtotal += itemTotal;
        const cartItemHTML = `
          <div class="baby-shower-cart-item" data-variant-id="${item.variantId}">
            <img src="${item.imageUrl}" alt="${item.title}" class="baby-shower-cart-item-image">
            <div class="baby-shower-cart-item-details">
              <span class="baby-shower-cart-item-title">${item.title}</span>
              <span class="baby-shower-cart-item-variant"><a href="https://minibee.cl/collections/vendors?q=${item.brand}" target="_blank" rel="noopener noreferrer">${item.brand || ''}</a></span>
              ${priceHtml}
              <div class="baby-shower-cart-item-quantity-controls">
                <button class="quantity-btn decrease-btn">
                  <svg width="9" height="1" fill="none">
                    <path fill="#111" d="M9 0v1H0V0h9Z"></path>
                  </svg>
                </button>
                <span class="quantity-value">${item.quantity}</span>
                <button class="quantity-btn increase-btn">
                  <svg width="9" height="9" fill="none">
                    <path fill="#111" fill-rule="evenodd" d="M4 9h1V5h4V4H5V0H4v4H0v1h4v4Z" clip-rule="evenodd"></path>
                  </svg>
                </button>
              </div>
            </div>
            <button class="baby-shower-cart-item-remove-btn">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>
            </button>
          </div>
        `;
        cartItemsContainer.innerHTML += cartItemHTML;
      });
    }

    cartSubtotalAmount.textContent = formatCurrency(subtotal);

    if (cartCountProductsTitle) cartCountProductsTitle.textContent = shoppingCart.length;

    const totalItems = shoppingCart.length;

    // Actualiza el contador del header
    if (cartCountElement) {
      cartCountElement.textContent = shoppingCart.length;
      cartCountElement.style.display = shoppingCart.length > 0 ? "flex" : "none";
    }

    // Actualiza el contador y visibilidad del botón flotante
    if (floatingCartBtn && floatingCartCount) {
      floatingCartCount.textContent = totalItems;
      if (totalItems > 0) {
        floatingCartBtn.classList.add("visible");
      } else {
        floatingCartBtn.classList.remove("visible");
      }
    }    

    cartCheckoutBtn.disabled = shoppingCart.length === 0;

    setupCartItemEventListeners();
  };

  // Muestra el modal del carrito.
  const openCartModal = () => {
    if (!cartModalOverlay) return;
    cartModalOverlay.classList.add("visible");
    document.documentElement.classList.add("remove-scrolling");
  };

  // Oculta el modal del carrito.
  const closeCartModal = () => {
    if (!cartModalOverlay) return;
    cartModalOverlay.classList.remove("visible");
    document.documentElement.classList.remove("remove-scrolling");
  };

  //-------------------------- 6. LÓGICA DE CHECKOUT -----------------------------//

  // Muestra el modal de pre-checkout para que el usuario llene sus datos.
  const showCheckoutModal = () => {
    if (shoppingCart.length === 0) {
      createAlertModal("Tu carrito de regalos está vacío.");
      return;
    }

    document.getElementById("checkoutModal")?.remove();

    // --- MODIFICADO --- Se añade el campo de teléfono.
    const modalHTML = `
      <div class="baby-shower-checkout-modal" id="checkoutModal">
        <div class="baby-shower-checkout-modal-content">
          <h3 class="baby-shower-checkout-modal-title">Confirmar Compra</h3>
          <p class="baby-shower-checkout-modal-subtitle">
            Estás a un paso de regalar. Por favor, completa tus datos de contacto para continuar. 🤎
          </p>
          <form id="checkoutForm" class="baby-shower-checkout-form" novalidate>
            <div class="baby-shower-form-group">
              <label for="buyerName">Nombre Completo*</label>
              <input type="text" id="buyerName" name="buyerName" minlength="6" maxlength="255" required placeholder="Ej: Juan Pérez">
              <span class="error-message">El nombre debe tener 6 a 100 caracteres.</span>
            </div>
            <div class="baby-shower-form-group">
              <label for="buyerEmail">Correo Electrónico*</label>
              <input type="email" id="buyerEmail" name="buyerEmail" maxlength="255" required placeholder="Ej: juan@email.com">
              <span class="error-message">Por favor, ingresa un correo válido.</span>
            </div>
            <div class="baby-shower-form-group">
              <label for="buyerPhone">Teléfono*</label>
              <input type="tel" id="buyerPhone" name="buyerPhone" required placeholder="Ej: 912345678" pattern="[0-9]{9}">
              <span class="error-message">Ingresa un teléfono válido de 9 dígitos (ej. 912345678).</span>
            </div>
            <div class="baby-shower-form-group">
              <label for="giftMessage">Agrega un mensaje especial para los padres</label>
              <textarea id="giftMessage" name="giftMessage" minlength="10" maxlength="500" placeholder="¡Felicidades por tu bebé! Que disfruten este regalo."></textarea>
              <span class="error-message">El mensaje debe tener entre 10 y 500 caracteres.</span>
            </div>
            <div class="baby-shower-checkout-buttons">
              <button type="button" class="baby-shower-checkout-cancel-btn">Cancelar</button>
              <button type="submit" class="baby-shower-checkout-confirm-btn">Ir A Pagar</button>
            </div>
          </form>
        </div>
      </div>
    `;

    document.body.insertAdjacentHTML("beforeend", modalHTML);
    const modal = document.getElementById("checkoutModal");
    setTimeout(() => {
      modal.classList.add("visible");
      document.documentElement.classList.add("remove-scrolling");
    }, 10);

    // Botón cancelar Checkout Modal
    modal.querySelector(".baby-shower-checkout-cancel-btn").addEventListener("click", () => {
      modal.remove();
    });
    // Botón pagar ahora Checkout Modal
    modal.querySelector("#checkoutForm").addEventListener("submit", handleCheckoutSubmit);
  };

  // Procesa el envío del formulario de checkout.
  const handleCheckoutSubmit = async (e) => {
    e.preventDefault();
    if(isSubmittingCheckoutCheckout) return; // Bloquear re-envios
    const form = e.target;
    const submitBtn = form.querySelector(".baby-shower-checkout-confirm-btn");
    const cancelBtn = form.querySelector(".baby-shower-checkout-cancel-btn");

    // Inputs
    const buyerNameInput = form.buyerName;
    const buyerEmailInput = form.buyerEmail;
    const buyerPhoneInput = form.buyerPhone;
    const giftMessageInput = form.giftMessage;

    // Agrupamos en un array
    const checkoutInputs = [buyerNameInput, buyerEmailInput, buyerPhoneInput, giftMessageInput];    

    // Agregar listener para limpiar errores al escribir
    function clearInputError(e) {
      e.target.classList.remove("input-error");
      e.target.nextElementSibling?.classList.remove("show-error");
    }

    checkoutInputs.forEach(input => {
      input.removeEventListener("input", clearInputError);
      input.addEventListener("input", clearInputError);
    });    

    // Valores
    const buyerName = buyerNameInput.value.trim();
    const buyerEmail = buyerEmailInput.value.trim();
    const buyerPhone = buyerPhoneInput.value.trim();
    const giftMessage = giftMessageInput.value.trim();

    // Resetear errores previos
    [buyerNameInput, buyerEmailInput, buyerPhoneInput, giftMessageInput].forEach(input => {
      input.classList.remove("input-error");
      input.nextElementSibling?.classList.remove("show-error");
    });

    // Validaciones
    let hasError = false;

    if (buyerName.length < 6 || buyerName.length > 100) {
      buyerNameInput.classList.add("input-error");
      buyerNameInput.nextElementSibling?.classList.add("show-error");
      hasError = true;
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(buyerEmail)) {
      buyerEmailInput.classList.add("input-error");
      buyerEmailInput.nextElementSibling?.classList.add("show-error");
      hasError = true;
    }

    if (!/^9[0-9]{8}$/.test(buyerPhone)) {
      buyerPhoneInput.classList.add("input-error");
      buyerPhoneInput.nextElementSibling?.classList.add("show-error");
      hasError = true;
    }

    if (giftMessage.length < 10 || giftMessage.length > 500) {
      giftMessageInput.classList.add("input-error");
      giftMessageInput.nextElementSibling?.classList.add("show-error");
      hasError = true;
    }

    if (hasError) return;

    isSubmittingCheckout = true;
    const modalCheckout = document.getElementById("checkoutModal");
    submitBtn.disabled = true;
    cancelBtn.disabled = true;
    submitBtn.innerHTML = `<svg class="loading-icon" width="24" height="24" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none"><g fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"><path d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8" opacity=".2"/><path d="M7.25.75A.75.75 0 0 1 8 0a8 8 0 0 1 8 8 .75.75 0 0 1-1.5 0A6.5 6.5 0 0 0 8 1.5a.75.75 0 0 1-.75-.75"/></g></svg>`;
    //console.log('Formulario enviado');
  
    try {
      // Obtenemos los datos de todos los productos y más
      const payload = {
        list_id: shoppingCart[0].list_id, // Obtenido del primer producto en el carrito
        buyer_name: buyerName,
        buyer_email: buyerEmail,
        buyer_phone: buyerPhone,
        gift_message: giftMessage,
        items: shoppingCart.map(item => ({
          variant_id: item.variantId,
          quantity: item.quantity,
          price: item.price,
        })),
      };

      const response = await fetch(`${API_BASE_URL}purchases`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      // Si la respuesta no es exitosa
      if (!result.success) {
        // Si hay detalles (por ejemplo stock insuficiente) los agregamos
        if (result.details && Array.isArray(result.details) && result.details.length > 0) {
          const items = result.details.map(d => `
            <div class="stock-error-item">
              <h4>${d.product_title}</h4>
              <div class="stock-error-item-container">
              <p>Agregados: <span>${d.requested_quantity}</span></p>
              <p>Disponible: <span style="color:${d.available_quantity === 0 ? '#c49a78' : '#c49a78'}">
                ${d.available_quantity}
              </span></p>
              </div>
            </div>
          `).join('');
          
          const content = `
            <p>Algunos productos no tienen stock suficiente:</p>
            ${items}
          `;
          
          showCheckoutErrorModal('Ocurrió un inconveniente', content);
        } else {
          // Otros errores
          showCheckoutErrorModal('Ocurrió un inconveniente', result.error || 'Ocurrió un error. Por favor intenta nuevamente.');
        }        
      
        submitBtn.disabled = false;
        cancelBtn.disabled = false;
        isSubmittingCheckout = false;
        submitBtn.textContent = "Ir A Pagar";
        return;
      }
    
      // Si no viene la URL
      if (!result.checkout_url) {
        showCheckoutErrorModal('Ocurrió un inconveniente', 'No se pudo generar la pasarela de pago. Por favor intenta nuevamente.');
        submitBtn.disabled = false;
        cancelBtn.disabled = false;
        isSubmittingCheckout = false;
        submitBtn.textContent = "Ir A Pagar";
        return;
      }

      // Si la respuesta es exitosa
      modalCheckout.remove();
      window.top.location.href = result.checkout_url;

    } catch (error) {
      console.error("Error en el checkout:", error);
      createAlertModal("Ocurrió un error de red. Por favor intenta nuevamente.");
      submitBtn.disabled = false;
      cancelBtn.disabled = false;
      isSubmittingCheckout = false;
      submitBtn.textContent = "Ir A Pagar";
    }
  };


  //-------------------------- 7. REGISTRO DE EVENT LISTENERS -----------------------------//

  // Registra los listeners para los botones dentro de cada item del carrito.
  const setupCartItemEventListeners = () => {
    document.querySelectorAll('.baby-shower-cart-item').forEach(itemElement => {
      const variantId = itemElement.dataset.variantId;
      itemElement.querySelector('.increase-btn')?.addEventListener('click', () => {
        const currentQty = shoppingCart.find(i => i.variantId === variantId)?.quantity || 0;
        updateCartItemQuantity(variantId, currentQty + 1);
      });
      itemElement.querySelector('.decrease-btn')?.addEventListener('click', () => {
        const currentQty = shoppingCart.find(i => i.variantId === variantId)?.quantity || 0;
        updateCartItemQuantity(variantId, currentQty - 1);
      });
      itemElement.querySelector('.baby-shower-cart-item-remove-btn')?.addEventListener('click', () => {
        removeFromCart(variantId);
      });
    });
  };

  // Registra los listeners globales (ícono del carrito, botones de cierre, etc.).
  const setupGlobalEventListeners = () => {

    // Botón flotante carrito
    if (floatingCartBtn) floatingCartBtn.addEventListener("click", openCartModal);

    // Botón carrito
    if (cartIconBtn) cartIconBtn.addEventListener("click", openCartModal);
    cartCloseBtns.forEach(btn => btn.addEventListener("click", closeCartModal));

    // Overlay Cart Modal Close
    if (cartModalOverlay) {
      cartModalOverlay.addEventListener("click", (e) => {
        if (e.target === cartModalOverlay) closeCartModal();
      });
    }

    // Button cartCheckout
    if (cartCheckoutBtn) cartCheckoutBtn.addEventListener("click", () => {
      showCheckoutModal();
    });
  };

  // EL PUENTE: Escucha los mensajes que vienen del iframe de Angular.
  const setupIframeMessageListener = () => {
    window.addEventListener("message", (event) => {
      // Seguridad
      if (event.origin !== ANGULAR_APP_ORIGIN) return;

      const {
        type,
        payload
      } = event.data;

      const data = event.data;

      if (type && payload) {
        //console.log('Type recibido: ', type);
        //console.log('Payload recibido: ', payload);
      }

      if (type === 'addToCart' && payload) {
        addToCart(payload);
      }

      if(data && data.type === 'resetCart') {
        resetCart();
      }

    });
  };

  //-------------------------- 8. INICIALIZACIÓN -----------------------------//

  //console.log('%c[PADRE-SHOPIFY]: Hanlder del Carrito INICIADO.', 'color: green; font-weight: bold;');
  setupGlobalEventListeners();
  setupIframeMessageListener();
  //updateCartDisplay(); // Para asegurar que el contador inicie en 0
});